// AmountCard.tsx ✅ FINAL (no dropdown, no internal view state)
import React, { useState } from "react";
import "./AmountCard.css";
import info from "../../../assets/icons/order-info.png";
import TotalAmountDetailsModal from "./WithdrawDetailsModal.tsx";

interface AmountCardProps {
  title: string;
  amount: string;
  pendingAmount: string;
  withdrawableAmount: string;
  icon: string;
  colorCode: string;
  usedIn?: string;
  orderHistoryLogDetailsAmount: any;
}

const AmountCard: React.FC<AmountCardProps> = ({
  title,
  amount,
  pendingAmount,
  withdrawableAmount,
  icon,
  colorCode,
  usedIn = "",
  orderHistoryLogDetailsAmount,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = (e: React.MouseEvent) => {
    e.stopPropagation(); e.preventDefault(); setOpen(true);
  };
  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation(); e.preventDefault(); setOpen(false);
  };
  const modalClick = (e: React.MouseEvent) => e.stopPropagation();

  return (
    <div className="amount-card d-flex flex-column gap-2">
      {/* Header */}
      <div className="d-flex gap-2 align-items-center justify-content-between">
        <div><div className="amount-text">{title}</div></div>
        <div className="amount-icon" style={{ backgroundColor: colorCode }}>
          <img src={icon} alt="icon" />
        </div>
      </div>

      <div><div className="amount">{amount}</div></div>
      <div>
        <div className="amount-text_sm_pending text-muted">
          Pending {usedIn}: <span className="amount_sm">{pendingAmount}</span>
        </div>
        <div className="amount-text_sm_withdrawable">
          Withdrawable {usedIn}: <span className="amount_sm">{withdrawableAmount}</span>
        </div>
      </div>

      <div onClick={handleOpen} style={{ position: 'absolute', bottom: '5px', right: '5px', cursor: 'pointer' }}>
        <img src={info} style={{ width: '20px', height: '20px' }} alt="info" />
      </div>

      {open && (
        <div onClick={modalClick}>
          <TotalAmountDetailsModal
            open={open}
            handleClose={handleClose}
            orderhistorylogdetailsamount={orderHistoryLogDetailsAmount}
          />
        </div>
      )}
    </div>
  );
};

export default AmountCard;